
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","data-name":"Raggruppa 796"}},[_c('g',{attrs:{"stroke":"#231f20","stroke-width":".3","data-name":"Ellisse 73"}},[_c('circle',{attrs:{"cx":"24","cy":"24","r":"24","stroke":"none"}}),_c('circle',{attrs:{"cx":"24","cy":"24","r":"23.85"}})]),_c('path',{attrs:{"stroke":"#000","stroke-linecap":"round","stroke-width":"2","d":"M25.725 32.685l-4.722-8.331 4.722-8.327","data-name":"Tracciato 866"}})])])
          )
        }
      }
    